import React from 'react';
import './WorkStationTool.css';

const WorkstationTools = () => {
  return (
    <div className="container">
      <section className="section">
        <h2>Workstation</h2>
        <div className="item">
          <h3>16″ MacBook Pro, M2, 32GB RAM (2023)</h3>
          <p>
            Before this, I had been working on a 16-inch MacBook Pro with an M2 Pro Chip. The
            disparity between the two is striking. Despite subjecting it to the intense strain of our
            numerous launch simulations, I have yet to hear the fans whirring even once since
            switching to the new system.
          </p>
        </div>
        <div className="item">
          <h3>LG UltraFine Display Ergo 4k (32 Inch)</h3>
          <p>
            A high-quality monitor that boasts a stunning 4K resolution and ergonomic design
            features, making it a great choice for professionals who require both performance and
            comfort.
          </p>
        </div>
      </section>
      <section className="section">
        <h2>Development tools</h2>
        <div className="item">
          <h3>WebStrom</h3>
          <p>
            A powerful IDE for programming that offers advanced features such as code
            analysis, both remote and local debugging, and testing tools, making it a top choice for
            developers who work with JS.
          </p>
        </div>
        <div className="item">
          <h3>Sublime Text</h3>
          <p>
            Despite lacking the fancy IDE features that most people depend on, Sublime Text remains
            the greatest text editor ever created, in my opinion.
          </p>
        </div>
        <div className="item">
          <h3>TablePlus</h3>
          <p>
            This exceptional database software has spared me the need to create countless admin
            interfaces for my diverse projects throughout the years.
          </p>
        </div>
        <div className="item">
          <h3>Xcode</h3>
          <p>
            Xcode is Apple's integrated development environment (IDE) for macOS, used to develop software for
            macOS, iOS, iPadOS, watchOS, and tvOS. It includes a suite of software development tools
            developed by Apple.
          </p>
        </div>
        <div className="item">
          <h3>Android Studio</h3>
          <p>
            Android Studio is the official IDE for Google's Android operating system, built on JetBrains' IntelliJ IDEA
            software and designed specifically for Android development.
          </p>
        </div>
      </section>
    </div>
  );
};

export default WorkstationTools;
